export const MESSAGES = {
    ERRORS: {
      FILE: {
        INVALID_TYPE: 'Invalid file type. Please upload a valid Excel file (.xls or .xlsx).',
        EMPTY: 'Excel file is empty or contains only headers',
        EXCEPTION: 'An error occurred while processing the file',
        MISSING_COLUMNS: (columns: string[]) => `Missing required columns: ${columns.join(', ')}`,
      }
    }
  } as const;